import { render, staticRenderFns } from "./ReviewDashboardProfee.vue?vue&type=template&id=e5ca5e6e&scoped=true&"
import script from "./ReviewDashboardProfee.vue?vue&type=script&lang=js&"
export * from "./ReviewDashboardProfee.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDashboardProfee.vue?vue&type=style&index=0&id=e5ca5e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ca5e6e",
  null
  
)

export default component.exports